/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateLocationDto } from '../models/CreateLocationDto';
import type { UpdateLocationDto } from '../models/UpdateLocationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LocationsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Listar ubicaciones (paginado)
   * @returns any Lista de ubicaciones con paginación
   * @throws ApiError
   */
  public locationsControllerFindAll({
    page = 1,
    limit = 10,
    search,
    type,
    parentId,
    isActive,
    sortBy = 'name',
    sortOrder = 'asc',
  }: {
    /**
     * Número de página (1-indexed)
     */
    page?: number,
    /**
     * Cantidad de registros por página
     */
    limit?: number,
    /**
     * Búsqueda por nombre
     */
    search?: string,
    /**
     * Filtrar por tipo de ubicación
     */
    type?: 'SEDE' | 'PISO' | 'AREA' | 'ESPACIO',
    /**
     * Filtrar por ubicación padre
     */
    parentId?: string,
    /**
     * Filtrar por estado activo (true/false)
     */
    isActive?: boolean,
    /**
     * Campo de ordenamiento (name, type, createdAt)
     */
    sortBy?: string,
    /**
     * Dirección de ordenamiento
     */
    sortOrder?: 'asc' | 'desc',
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/locations',
      query: {
        'page': page,
        'limit': limit,
        'search': search,
        'type': type,
        'parentId': parentId,
        'isActive': isActive,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        401: `No autenticado`,
      },
    });
  }
  /**
   * Crear nueva ubicación
   * @returns any Ubicación creada exitosamente
   * @throws ApiError
   */
  public locationsControllerCreate({
    requestBody,
  }: {
    requestBody: CreateLocationDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/locations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos o jerarquía inválida`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        409: `Ya existe una ubicación con este nombre en el mismo nivel`,
      },
    });
  }
  /**
   * Obtener árbol jerárquico de ubicaciones
   * @returns any Árbol de ubicaciones
   * @throws ApiError
   */
  public locationsControllerGetTree(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/locations/tree',
      errors: {
        401: `No autenticado`,
      },
    });
  }
  /**
   * Obtener ubicación por ID
   * @returns any Detalles de la ubicación
   * @throws ApiError
   */
  public locationsControllerFindOne({
    id,
  }: {
    /**
     * ID de la ubicación (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/locations/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `No autenticado`,
        404: `Ubicación no encontrada`,
      },
    });
  }
  /**
   * Actualizar ubicación
   * @returns any Ubicación actualizada exitosamente
   * @throws ApiError
   */
  public locationsControllerUpdate({
    id,
    requestBody,
  }: {
    /**
     * ID de la ubicación (UUID)
     */
    id: string,
    requestBody: UpdateLocationDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/locations/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Ubicación no encontrada`,
        409: `Ya existe una ubicación con este nombre en el mismo nivel`,
      },
    });
  }
  /**
   * Eliminar ubicación
   * @returns any Ubicación eliminada exitosamente
   * @throws ApiError
   */
  public locationsControllerRemove({
    id,
  }: {
    /**
     * ID de la ubicación (UUID)
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/locations/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `No se puede eliminar (tiene hijos o activos asignados)`,
        401: `No autenticado`,
        403: `Permisos insuficientes`,
        404: `Ubicación no encontrada`,
      },
    });
  }
}
